import { useAppDataContext } from '@cox/core-ui8/dist/AppDataContext'
import { Breadcrumb } from '@cox/core-ui8/dist/Breadcrumb'

import { INVERSION_PAGE_TYPES } from '../../constants'
import withAEM from '../../hoc/withAEM'
import { useInversionData } from '../../hooks/useInversionData'
import { capitalizeString, getSlugfromUrl } from '../../utils/helper-util'
import { INVERSION_BREADCRUMB_PREFIX } from '../../utils/inversion-util'

const ReactBreadcrumb = (props: any) => {
  const currentUrl = window.location.pathname
  const currentOrigin = window.location.origin
  const urlParts = currentUrl?.split('/')
  const { appData } = useAppDataContext()
  const inversionItems = useInversionData()
  const firstItem = inversionItems?.[0] ?? {}
  const { templates = '', address_city = '', slug = '' } = firstItem
  const { isLocal = '', pageType = '' } = appData?.page ?? {}
  const templatePages = templates.split(',')
  const templatePageIndex = templatePages?.findIndex((item: string) => item.toLowerCase() === getSlugfromUrl(currentUrl))

  const breadcrumbItemvalues = urlParts?.map((part, index) => {
    const active = index === urlParts.length - 1
    const href = `${currentOrigin}${urlParts?.slice(0, index + 1)?.join('/')}.html`
    const target = '_self'
    const text = part?.charAt(0)?.toUpperCase() + part?.slice(1).replace('.html', '')
    const title = part

    return {
      active,
      href,
      target,
      text,
      title
    }
  })

  let breadcrumbJson = {}

  if (isLocal === 'true') {
    breadcrumbJson = breadcrumbItemvalues
      .map((item, index) => {
        if (index === 3) {
          item.text = INVERSION_BREADCRUMB_PREFIX + item.text
        } else if (index === 4) {
          item.text = item.text.toUpperCase()
        } else if (index === 5) {
          item.text = address_city
        } else if (index === 6) {
          item.text = pageType.includes(INVERSION_PAGE_TYPES.services_offers)
            ? templatePages[templatePageIndex] || item.text
            : capitalizeString(slug)
        }
        return item
      })
      .filter((item, index) => index > 2)
  } else {
    breadcrumbJson = breadcrumbItemvalues
  }

  const BreadcrumbWithAEM = withAEM(Breadcrumb)

  return <BreadcrumbWithAEM {...props} breadcrumbItems={breadcrumbJson} compName={'React Breadcrumb'} />
}
export default ReactBreadcrumb
